import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb51a9aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cb51a9aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb51a9aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb51a9aa')) {
      api.createRecord('cb51a9aa', component.options)
    } else {
      api.reload('cb51a9aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb51a9aa&scoped=true", function () {
      api.rerender('cb51a9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubi/index.vue"
export default component.exports